import { makeAutoObservable } from 'mobx';
import { clearPersistedStore, makePersistable } from 'mobx-persist-store';

const DEFAULT_STATE = {
  paginationState: { pageIndex: 0, pageSize: 10 },
  filters: {},
  sorting: {},
};

/**
 * Factory for list stores that persist pagination, filters, and sorting.
 * Use one per module to avoid repeating the same store implementation.
 * @param {string} persistName - Name for mobx-persist-store (e.g. 'flowDefinitionsListStore')
 * @returns {class} Store class to instantiate with rootStore
 */
function createListStore(persistName) {
  class ListStore {
    params = JSON.stringify({});

    constructor(rootStore) {
      this.rootStore = rootStore;
      makeAutoObservable(this);
      makePersistable(this, {
        name: persistName,
        properties: ['params'],
      });
    }

    set(newParams) {
      this.params = JSON.stringify({
        ...DEFAULT_STATE,
        ...newParams,
      });
    }

    get() {
      const currentData = JSON.parse(this.params);
      return { ...DEFAULT_STATE, ...currentData };
    }

    async clearStore() {
      await clearPersistedStore(this);
    }
  }

  return ListStore;
}

export default createListStore;
